import { get } from '@/services/http';
import {
  InventoryTransferSuggestionModel,
  InventoryTransferSuggestionAPIInterface,
} from '@/models/inventory_transfer_suggestion';

export interface GetSuggestionsParams {
  fromLocationId?: number;
  toLocationId?: number;
}

export class InventoryTransferSuggestions {
  public items: InventoryTransferSuggestionModel[] = [];
  public total: number = 0;

  public async fetch(
    params: GetSuggestionsParams = {},
  ): Promise<void> {
    console.log('🔗 InventoryTransferSuggestions.fetch called with params:', params);
    const response: any = await get('/inventory-transfers/suggestions', params);
    console.log('🔗 Raw API response:', response);
    console.log('🔗 Response data array:', response.data);

    this.items = response.data.map(
      (suggestion: InventoryTransferSuggestionAPIInterface) => {
        console.log('🔗 Mapping suggestion:', suggestion);
        const mapped = new InventoryTransferSuggestionModel().mapData(suggestion);
        console.log('🔗 Mapped result:', mapped);
        return mapped;
      },
    );
    this.total = this.items.length;
    console.log('🔗 Final items array:', this.items);
    console.log('🔗 Total items:', this.total);
  }
}
